module.exports = __webpack_public_path__ + "img/SCweather_detail.8a1a4391.png";